import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Custom hook to ensure proper browser navigation
export const useNavigationFix = () => {
  const location = useLocation()

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0)
  }, [location.pathname])
}